import React from 'react';
import Content from 'components/_ui/Content';
import RichText from 'components/RichText';
import styled from '@emotion/styled';
/*import colors from 'styles/colors';*/
import dimensions from 'styles/dimensions';
import { Inner, Wrap } from 'styles/structure';
import { Rubric } from 'styles/typography';
import { Link } from 'gatsby';
import Button from 'components/_ui/Button';

const ToutContainer = styled.div`
  position: relative;
  display: block;
  text-align: center;
  
  & + * {
    margin-top: 8rem;
  }
  
  &:last-of-type {
    margin-bottom: 8rem;
  }
  
  header {
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 12rem;
    }
    
    &:last-of-type {
      margin-top: 12rem;
    }
  }
`;

const ToutButtons = styled.div`
  text-align: center;
  margin-top: 3.2rem;
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    margin-top: 5.6rem;
  }
`;

const Tout = ({ id, intro, heading, content, buttonText, destination }) => {
  let renderedHeading;

  if (heading && heading[0] && heading[0].text) {
    renderedHeading = (<RichText render={heading}/>);

  } else {
    renderedHeading = (<h4>{heading}</h4>);
  }

  return (
    <ToutContainer id={id}>
      <Inner>
        <Wrap>
          <header>
            {intro && <Rubric>{intro}</Rubric>}

            {renderedHeading}
          </header>

          {content && <Content content={content}/>}

          {(buttonText && destination) && (
            <ToutButtons>
              <Button as={Link} to={destination}>{buttonText}</Button>
            </ToutButtons>
          )}
        </Wrap>
      </Inner>
    </ToutContainer>
  );
};

export default Tout;
